import React from "react";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from 'react-i18next';
import styled, { keyframes, } from 'styled-components';

import { Accessibility } from "./accessibility";
import { NavLinks } from "./navLinks";
import { DeviceSize } from "../responsive";
import { MobileNavLinks } from "./mobileNavLinks";

import Avatar from "../Avatar";

const NavbarContainer = styled.div` width: 100%; height: 26px; margin: 0; 
                                    box-shadow: 0 1px 3px rgba(15, 15, 15, 0.13); 
                                    display: flex; align-items: center; background-color: #d4d7db; 
                                    border: 0; `;
const LeftSection = styled.div` display: flex; align-items: left; width: 29px; height: 29px; 
                                margin-right: 10px; 
                                img { width: 100%; height: 100%; } `;
const LanguagesSection = styled.div` display: flex; `;
const MiddleSection = styled.div` display: flex; flex: 2; height: 100%; justify-content: center; `;
const RightSection = styled.div` display: flex; `;
const TenSpacesH = styled.div` width: 10px;`;

const rotation = keyframes` from { transform: rotate(0deg); } to { transform: rotate(360deg); } `
const Rotate = styled.div` animation: ${rotation} 5s linear infinite; `

const Languages = [ { code: 'en', name: 'English',  country_code: 'gb', },
                    { code: 'fr', name: 'Français', country_code: 'fr', },
                    { code: 'ar', name: 'العربية',  dir: 'rtl', country_code: 'sa', },
                    { code: 'de', name: 'Deutsch',  country_code: 'de', }, ]
                    
export default function Navbar() 
{ const isMobile = useMediaQuery({ maxWidth: DeviceSize.mobile } );

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => { i18n.changeLanguage(lng); };
                         
  return ( <NavbarContainer>
              <LeftSection>
                 <Rotate> <Avatar /> </Rotate>
              </LeftSection>
              <LanguagesSection>
                 <div className="switcher">
                    {/* Language switch dropdown here */}
                    <select onChange={({ target: { value} }) => changeLanguage(value)}>
                       { Languages.map(({ code, name}) => 
                                       ( <option key={code} value={code} > {name} </option> )
                                      )
                       }
                     </select>
                 </div>
                 <TenSpacesH /><TenSpacesH /><TenSpacesH />
              </LanguagesSection>
              <MiddleSection>{!isMobile && <NavLinks />}</MiddleSection>
              <RightSection>{!isMobile && <Accessibility />}{isMobile && <MobileNavLinks />}</RightSection>
           </NavbarContainer> 
         );
}